<template>
    <div id="body" class="fade-in">
        <div id="blurWallpaper">
        </div>

        <div class="container" id="divProdutos">
            <div class="row">
                <div class="col">
                    <div id="logoContainer">
                        <img id="logoApp" src="../../../../assets/colab-food/logo.png" alt="logo">
                    </div>

                    <!--Luiz Trindade - Opções de ações-->
                    <div v-show="acao != 'alterar-produto'" class="container" style="margin-top: 20px;">
                        <div class="row">
                            <div class="col">
                                <div class="input-group mb-3">
                                    <label class="input-group-text" for="inputGroupSelect01">Opções</label>
                                    <select class="form-select" id="inputGroupSelect01" v-model="acao">
                                        <option value="visualizar">Visualizar produtos</option>
                                        <option value="cadastrar">Cadastrar produto</option>
                                        <option value="alterar">Alterar produto</option>
                                        <option value="deletar">Deletar produto</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Luiz Trindade - Visualizar produtos-->
                    <div v-show="acao == 'visualizar' || acao == 'alterar' || acao == 'deletar'" class="container">
                        <div class="row">
                            <div class="col">
                                <div style="overflow-x: auto; max-width: auto; max-height: 500px;">
                                    <table class="table table-bordered table-striped table-hover">
                                        <!--Luiz Trindade - Cabeçalho da tabela-->
                                        <thead class="table-dark">
                                            <tr>
                                                <th v-show="acao == 'alterar' || acao == 'deletar'">Ação</th>
                                                <th>Código</th>
                                                <th>Nome</th>
                                                <th>Quantidade</th>
                                                <th>Valor Un.</th>
                                                <th>Total</th>
                                                <th>Vendas</th>
                                                <th>Data adição</th>
                                            </tr>
                                        </thead>

                                        <!--Luiz Trindade - Corpo da tabela-->
                                        <tbody v-if="listaProdutos.length > 0">
                                            <tr v-for="produto in listaProdutos">
                                                <td v-show="acao == 'alterar'" @click="selecionarProdutoParaAlterar(produto[0], produto[1], produto[2], produto[3])">
                                                    <button class="btn btn-primary">
                                                        <i class="bi bi-pencil-square"></i>
                                                    </button>
                                                </td>

                                                <td v-show="acao == 'deletar'">
                                                    <button class="btn btn-danger" @click="deletarProduto(produto[0], produto[1])">
                                                        <i class="bi bi-trash3-fill"></i>
                                                    </button>
                                                </td>

                                                <td>{{ produto[0] }}</td>
                                                <td style="text-align: left;">{{ produto[1] }}</td>
                                                <td>{{ produto[2] }}</td>
                                                <td style="text-align: right;">R${{ parseFloat(produto[3]).toFixed(2) }}</td>
                                                <td style="text-align: right;">R${{ parseFloat(produto[2] * produto[3]).toFixed(2) }}</td>
                                                <td>{{ produto[4] }}</td>
                                                <td>{{ produto[5].split('-').reverse().join('/') }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Luiz Trindade - Cadastrar um produto-->
                    <div v-show="acao == 'cadastrar'" id="cadastrarProdutos" class="container" style="margin-top: 20px">
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-boxes"></i>
                            </span>
                            <input v-model="nomeProduto" type="text" class="form-control" placeholder="Nome do produto" aria-label="Username" aria-describedby="basic-addon1">
                        </div>
    
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-123"></i>
                            </span>
                            <input v-model="quantidadeProduto" type="number" class="form-control" placeholder="Quantidade" aria-label="Username" aria-describedby="basic-addon1">
                        </div>
    
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-cash-coin"></i>
                            </span>
                            <input v-model="valorProduto" type="text" class="form-control" placeholder="Valor" aria-label="Username" aria-describedby="basic-addon1">
                        </div>

                        <div class="row">
                            <div class="col">
                                <button class="btn btn-success" style="font-size: 20px;" @click="cadastrarProduto()">
                                    <i class="bi bi-floppy-fill"></i>
                                    <b>
                                        Cadastrar produto
                                    </b>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--Luiz Trindade - Alterar produto-->
                    <div v-show="acao == 'alterar-produto'" class="container" style="margin-top: 20px;">
                        <h1 style="color: white;">
                            <b>
                                Alterar produto
                            </b>
                        </h1>

                        <!--Luiz Trindade - Nome do produto-->
                        <div class="input-group mb-3" style="margin-top: 10px;">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-boxes"></i>
                            </span>
                            <input v-model="nomeProduto" type="text" class="form-control" placeholder="Nome do produto" aria-label="Username" aria-describedby="basic-addon1">
                        </div>
    
                        <!--Luiz Trindade - Quantidade do produto-->
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-123"></i>
                            </span>
                            <input v-model="quantidadeProduto" type="number" class="form-control" placeholder="Quantidade" aria-label="Username" aria-describedby="basic-addon1">
                        </div>
                        
                        <!--Luiz Trindade - Valor do produto-->
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="bi bi-cash-coin"></i>
                            </span>
                            <input v-model="valorProduto" type="text" class="form-control" placeholder="Valor" aria-label="Username" aria-describedby="basic-addon1">
                        </div>

                        <div class="row">
                            <div class="col">
                                <!--Luiz Trindade - Botão de alterar-->
                                <button class="btn btn-success" style="font-size: 20px;" @click="alterarProduto()">
                                    <i class="bi bi-pencil-square"></i>
                                    <b>
                                        Alterar produto
                                    </b>
                                </button>
                            </div>
                            
                            <!--Luiz Trindade - Botão de cancelar alteração-->
                            <div class="col">
                                <button class="btn btn-danger" style="font-size: 20px;" @click="acao = 'visualizar'">
                                    <i class="bi bi-x-circle-fill"></i>
                                    <b>
                                        Cancelar
                                    </b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Luiz Trindade - Footer ou Rodapé-->
        <footer id="footerSite" class="bg-dark text-white text-center py-3 mt-auto">
            <div class="container">
                <p class="mb-0">© 2024 Grupo Colab. Todos os direitos reservados.</p>
                <p><a href="#" class="text-white">Termos de Serviço</a> | <a href="#" class="text-white">Política de
                        Privacidade</a></p>
                <p class="d-none d-sm-block">Siga-nos nas redes sociais!</p>
                <p>Este site utiliza código licenciado sob a <a href="https://mit-license.org/" target="_blank">Licença MIT</a>.</p>
            </div>
        </footer>
    </div>
</template>

<script>
//Importação do utils.js
import * as utils from '../../../../utils.js';
import Swal from 'sweetalert2';

export default {
    name: "colabFoodProdutos",

    //Luiz Trindade - Declaração de variáveis
    data() {
        return {
            acao                : "visualizar",
            listaProdutos       : [],
            codigoProduto       : 0,
            nomeProduto         : "",
            quantidadeProduto   : 0,
            valorProduto        : "",
        };
    },

    //Luiz Trindade - Importação de componentes
    components: {
    },

    //Luiz Trindade - Métodos que serão executados antes da aplicação ser criada
    beforeCreate() {
        //Luiz Trindade - Verificar se o usuário está logado
    },

    //Luiz Trindade - Métodos que serão executados no início da aplicação
    mounted() {
        utils.loader("start");
        this.verificarSessao();
        utils.loader();
    },

    //Luiz Trindade - Métodos padrões
    methods: {
        verificarSessao() {
            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            if (utils.verificarHash(codigo_usuarioHash)) {
                //Luiz Trindade - Fazer uma requisição para verificar a sessão
                this.$http.post(this.$servidorRota+'verificarsessao', {
                    codigo_usuario: codigo_usuarioHash
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.data == 0) {
                        //Luiz Trindade - Se a sessão for verdadeira, redirecionar para home
                        console.log("Usuário logado!");

                        //Luiz Trindade - Se estiver logado, lista os produtos mais vendidos
                        this.carregarProdutos();
                    } else {
                        //Se for um hash, mas o hash não for válido, vai para o login
                        this.$router.push("/services/colab-food/");
                    }

                    utils.loader();
                })
                .catch(error => {
                    utils.loader();
                });
            } else {
                //Se não for um hash, vai para o login
                this.$router.push("/services/colab-food/");
            }
        },

        //Luiz Trindade - Método para carregar os produtos na tabela de produtos
        carregarProdutos() {
            console.log("Carregando produtos...");
            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            this.$http.post(this.$servidorRota+'carregarprodutos', {
                codigo_usuario: codigo_usuarioHash
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                console.log(response.data);
                this.listaProdutos = response.data;
            })
            .catch(error => {
            });
        },

        //Luiz Trindade - Função para cadstrar um produto novo
        cadastrarProduto() {
            utils.loader("start");

            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            this.$http.post(this.$servidorRota+'cadastrarproduto', {
                nome            : this.nomeProduto,
                quantidade      : this.quantidadeProduto,
                valor           : this.valorProduto,
                codigo_usuario  : codigo_usuarioHash    
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (response.data == "success") {
                    utils.informar("Produto cadastrado com sucesso!");

                    this.acao = "visualizar";

                    this.nomeProduto        = "";
                    this.quantidadeProduto  = 0;
                    this.valorProduto       = "";

                    this.carregarProdutos();
                } else {
                    utils.informar("Erro ao cadastrar produto!");
                }

                utils.loader();
            })
            .catch(error => {
                console.error('Erro ao cadastrar produto:', error.response ? error.response.data : error.message);
                utils.loader();
            });
        },

        //Luiz Trindade - 
        deletarProduto(codigoProduto, produtoNome) {
            utils.loader("start");

            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            Swal.fire({
                title: `Deletar "${produtoNome}"?`,
                text: "Você não poderá reverter isso!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    utils.loader("start");
                    
                    this.$http.post(this.$servidorRota+'deletarproduto', {
                        codigo_produto  : parseInt(codigoProduto),
                        codigo_usuario  : codigo_usuarioHash    
                    }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        if (response.data == "success") {
                            utils.informar("Produto deletado com sucesso!");

                            this.acao = "visualizar";

                            this.carregarProdutos();
                        } else {
                            utils.informar("Erro ao deletar produto!");
                        }

                        utils.loader();
                    })
                    .catch(error => {
                        console.error('Erro ao deletar produto:', error.response ? error.response.data : error.message);
                        utils.loader();
                    });
                }
            });

            utils.loader();
        },

        //Luiz Trindade - Função para selecionar para alteraração
        selecionarProdutoParaAlterar(codigoProduto, nomeProduto, quantidadeProduto, valorProduto) {
            this.acao               = "alterar-produto";
            this.codigoProduto      = codigoProduto;
            this.nomeProduto        = nomeProduto;
            this.quantidadeProduto  = quantidadeProduto;
            this.valorProduto       = valorProduto;
        },

        //Luiz Trindade - Função de alterar o produto
        alterarProduto() {
            utils.loader("start");

            Swal.fire({
                title: `Alterar produto?`,
                text: "Você poderá alterar de volta caso deseje.",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, alterar!",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    utils.loader("start");

                    const codigo_usuarioHash = localStorage.getItem("codigo_usuario");
                    
                    this.$http.post(this.$servidorRota+'alterarproduto', {
                        codigo_produto  : this.codigoProduto,
                        nome            : this.nomeProduto,
                        quantidade      : this.quantidadeProduto,
                        valor           : this.valorProduto.toString(),
                        codigo_usuario  : codigo_usuarioHash    
                    }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        if (response.data == "success") {
                            utils.informar("Produto alterado com sucesso!");
                            
                            this.acao               = "visualizar";
                            this.codigoProduto      = 0;
                            this.nomeProduto        = "";
                            this.quantidadeProduto  = 0;
                            this.valorProduto       = "";

                            this.carregarProdutos();
                        } else {
                            utils.informar("Erro ao alterar produto!");
                        }
                        
                        utils.loader();
                    })
                    .catch(error => {
                        console.error('Erro ao alterar produto:', error.response ? error.response.data : error.message);
                        utils.loader();
                    });
                }
            });

            utils.loader();
        }
    },

    computed: {
    },

    watch: {
    }
}
</script>

<style scoped>
.fade-in {
    opacity: 0;
    /* Começa invisível */
    animation: fadeIn 2.5s forwards;
    /* Aplica a animação */
}
@keyframes fadeIn {
    to {
        opacity: 1;
        /* Finaliza visível */
    }
}

#body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: auto;
    background-image: url("../../../../assets/colab-food/login_background.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}

#blurWallpaper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 0;
    
    /* background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(5px); */
    
    background: linear-gradient(
    rgba(0, 0, 0, 0.6), 
    rgba(0, 0, 0, 1)
  );
}

#divProdutos {
    margin-top: 20px;
    background-color: rgba(0, 0, 0, .5);
    padding: 40px;
    border-radius: 10px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    z-index: 2;
    /* backdrop-filter: blur(5px); */
}

#logoContainer {
    text-align: center;
}

#logoApp {
    height: 150px;
    border-radius: 20px;
}

#footerSite {
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 2 4px 6px rgba(0, 0, 0, .5);
    margin-top: 50px !important;
}
</style>